<template>
  <CSection title="保单详情">
    <h3>企业复工综合保险</h3>
    <section class="section pt-4">
      <h4>基本信息</h4>
      <div>
        <v-layout class="section-row">
          <label class="label">投保资料：</label>
          <img :src="policy.policyPdfUrl" alt width="133" />
          <iframe :src="policy.policyPdfUrl" width='50%' height='100%' frameborder='1'></iframe>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">投保情况：</label>
          <div>{{policy.policySituation}}<span v-if="policy.policyNo">（上年保单号{{policy.policyNo}}）</span></div>
        </v-layout>
      </div>
    </section>
    <hr class="line" />
    <section class="section">
      <h4>投保人信息</h4>
      <div>
        <v-layout class="section-row">
          <label class="label">客户名称：</label>
          <span>{{policy.applicantName}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">组织机构代码/统一社会信用代码：</label>
          <span>{{policy.applicantIdentifyNumber}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">地址：</label>
          <span>{{policy.applicantAddress}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">邮政编码：</label>
          <span>{{policy.applicantPostCode}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">联系人姓名：</label>
          <span>{{policy.applicantContactName}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">联系电话：</label>
          <span>{{policy.applicantContactMobile}}</span>
        </v-layout>
      </div>
    </section>
    <hr class="line" />
    <section class="section">
      <h4>被保险人信息</h4>
      <div>
        <v-layout class="section-row">
          <label class="label">客户名称：</label>
          <span>{{policy.insuredName}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">组织机构代码/统一社会信用代码：</label>
          <span>{{policy.insuredIdentifyNumber}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">地址：</label>
          <span>{{policy.insuredAddress}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">邮政编码：</label>
          <span>{{policy.insuredPostCode}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">联系人姓名：</label>
          <span>{{policy.insuredConcatName}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">联系电话：</label>
          <span>{{policy.insuredMobile}}</span>
        </v-layout>
      </div>
    </section>
    <hr class="line" />
    <section class="section">
      <h4>投保信息</h4>
      <div>
        <v-layout class="section-row">
          <label class="label">被保险财产坐落地址：</label>
          <span>{{policy.insuredPropertyAddress}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">营业性质：</label>
          <span>{{policy.insuredBusinessNature}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">行业：</label>
          <span>{{policy.insuredIndustry}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">被保险人企业性质：</label>
          <span>{{policy.insuredEnterpriseNature}}</span>
        </v-layout>
      </div>
    </section>
    <hr class="line" />
    <section class="section">
      <h4>方案信息</h4>
      <div>
        <v-layout class="section-row">
          <label class="label">主险：</label>
          <span>{{policy.mainRisk}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">附加传染病营业中断保险：</label>
          <span>{{policy.planId}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">保险期限：</label>
          <span>自{{policy.startDate}}起至{{policy.endDate}} 00:00至，共{{policy.insurancePeriod}}个月（主险附加险保期一致）</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">总保险金额：</label>
          <span>{{policy.amount}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">总保险费：</label>
          <span>{{policy.prem}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">缴费计划：</label>
          <span v-if="policy.payPeriod === 1">一次交清</span>
          <span>{{policy.payPeriodExplain}}</span>
        </v-layout>
        <v-layout class="section-row">
          <label class="label">保险标的是否向其他保险公司投保同类保险：</label>
          <span>{{policy.isFlag === 1 ?'是':'否'}}</span>
          <span>{{policy.flagExplain}}</span>
        </v-layout>
      </div>
    </section>
  </CSection>
</template>

<script>
export default {
  props: {
    policy: Object
  },
  data() {
    return {};
  }
};
</script>